module.exports = __webpack_public_path__ + "img/article10.243c0e16.jpeg";